const base64UrlEncode = buffer => btoa(String.fromCharCode(...new Uint8Array(buffer)))
  .replace(/\+/g, '-')
  .replace(/\//g, '_')
  .replace(/=+$/, '')

export const generateCodeVerifier = () => base64UrlEncode(crypto.getRandomValues(new Uint8Array(32)))

export const generateCodeChallenge = async verifier => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))
  return base64UrlEncode(digest)
}

export const generateState = () => base64UrlEncode(crypto.getRandomValues(new Uint8Array(16)))
